import { Get, Post, Put } from "utils";

const QUESTION_BANK_PATH = "question-bank";

const unwrap = (response) => response?.data ?? response;

export const getQuestionBank = async () => {
  const data = unwrap(await Get(QUESTION_BANK_PATH));
  if (Array.isArray(data)) return data;
  return data?.questions || data?.items || [];
};

export const getQuestionBankQuestion = async ({ bankQuestionId }) => {
  const data = unwrap(await Get(`${QUESTION_BANK_PATH}/${encodeURIComponent(bankQuestionId)}`));
  return data?.question || data;
};

export const createQuestionBankQuestion = async ({ payload }) => {
  const data = unwrap(await Post(QUESTION_BANK_PATH, payload));
  return data?.question || data;
};

export const updateQuestionBankQuestion = async ({ bankQuestionId, payload }) => {
  return unwrap(await Put(`${QUESTION_BANK_PATH}/${encodeURIComponent(bankQuestionId)}`, payload));
};
